import React from 'react';
import { Modal, Pressable, Text, View, StyleSheet } from 'react-native';
import { Paprika } from '../../../styles/theme';
import { useTranslation } from 'react-i18next';

interface Props {
  visible: boolean;
  portions: number;
  onConfirm: (n: number) => void;
  onClose: () => void;
}

export function PortionsModal({ visible, portions, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  const [local, setLocal] = React.useState(portions);

  React.useEffect(() => { setLocal(portions); }, [portions]);

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable style={styles.scrim} onPress={onClose}>
        <Pressable style={styles.card} onPress={() => {}}>
          <Text style={styles.heading}>{t('thisWeek.portionsLabel')}</Text>
          <View style={styles.stepperRow}>
            <Pressable
              style={[styles.stepBtn, local <= 1 && styles.stepBtnDisabled]}
              onPress={() => setLocal(Math.max(1, local - 1))}
            >
              <Text style={styles.stepBtnText}>−</Text>
            </Pressable>
            <Text style={styles.number}>{local}</Text>
            <Pressable
              style={[styles.stepBtn, local >= 12 && styles.stepBtnDisabled]}
              onPress={() => setLocal(Math.min(12, local + 1))}
            >
              <Text style={styles.stepBtnText}>+</Text>
            </Pressable>
          </View>
          <Pressable style={styles.confirmBtn} onPress={() => { onConfirm(local); onClose(); }}>
            <Text style={styles.confirmBtnText}>{t('common.done')}</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  scrim: {
    flex: 1,
    backgroundColor: 'rgba(27, 28, 26, 0.48)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    width: 322,
    backgroundColor: Paprika.surfaceLowest,
    borderRadius: 20,
    padding: 32,
    alignItems: 'center',
    gap: 24,
    shadowColor: 'rgba(82, 68, 60, 0.12)',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 24,
  },
  heading: {
    fontFamily: 'Newsreader-Italic',
    fontSize: 22,
    color: Paprika.textPrimary,
  },
  stepperRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  stepBtn: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: Paprika.surfaceLow,
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepBtnDisabled: {
    opacity: 0.35,
  },
  stepBtnText: {
    fontFamily: 'Inter-Regular',
    fontSize: 24,
    color: Paprika.textPrimary,
    lineHeight: 26,
  },
  number: {
    fontFamily: 'Newsreader-Italic',
    fontSize: 52,
    color: Paprika.textPrimary,
    minWidth: 60,
    textAlign: 'center',
    lineHeight: 60,
  },
  confirmBtn: {
    backgroundColor: Paprika.primary,
    borderRadius: 100,
    paddingHorizontal: 32,
    paddingVertical: 14,
    width: '100%' as any,
    alignItems: 'center',
  },
  confirmBtnText: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 15,
    color: '#fff',
  },
});
